import cn from "clsx";
import HelpLink from "../HelpLink";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
var ContentItemsSidebar = function ContentItemsSidebar(_ref) {
  var isDark = _ref.isDark,
    renderLinks = _ref.renderLinks,
    renderBottomLinks = _ref.renderBottomLinks,
    className = _ref.className,
    sidebarCollapsed = _ref.sidebarCollapsed,
    isSidebarV2Enabled = _ref.isSidebarV2Enabled;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("div", {
      className: cn('w-full overflow-x-hidden overflow-y-auto pb-8', className),
      style: {
        flexGrow: 1
      },
      children: renderLinks({
        isDark: isDark,
        classNameLink: 'w-full flex items-center px-20 py-12 focus:outline-none cursor-pointer'
      })
    }), !isSidebarV2Enabled && Boolean(renderBottomLinks) ? /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("div", {
        className: cn('w-full border-t border-solid my-4', isDark ? 'border-base-lighter-16' : 'border-gray-light')
      }), /*#__PURE__*/_jsx("div", {
        className: "w-full overflow-x-hidden overflow-y-hidden pb-8",
        style: {
          flex: 'inherit'
        },
        children: renderBottomLinks && renderBottomLinks({
          isDark: isDark,
          classNameLink: 'w-full flex items-center px-20 py-12 focus:outline-none cursor-pointer'
        })
      })]
    }) : /*#__PURE__*/_jsx(HelpLink, {
      isDark: !!isDark,
      sidebarCollapsed: sidebarCollapsed
    })]
  });
};
export default ContentItemsSidebar;